// src/components/MobileWrapper.tsx
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

export const MobileWrapper: React.FC<{children: React.ReactNode}> = ({ children }) => {
  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      // Dynamic imports to avoid loading on web
      import('@capacitor/splash-screen').then(({ SplashScreen }) => {
        SplashScreen.hide().catch(error => {
          console.error('Error hiding splash screen in MobileWrapper:', error);
        });
      });
      
      // Set status bar style
      import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
        StatusBar.setBackgroundColor({ color: '#ffffff' }).catch(error => {
          console.error('Error setting status bar background:', error);
        });
        StatusBar.setStyle({ style: Style.Dark }).catch(error => {
          console.error('Error setting status bar style:', error);
        });
      }).catch(error => {
        console.error('Error importing StatusBar:', error);
      });
      
      // Handle hardware back button
      document.addEventListener('ionBackButton', (ev: any) => {
        ev.detail.register(10, () => {
          if (window.location.pathname !== '/app/calendar') {
            window.history.back();
          }
        });
      });
    }
  }, []);

  return <>{children}</>;
};